<template>
  <section id="articles">
    <Header :class="{header: true, hidden: false}"
      v-on:login="$emit('login')" :scrolled="true"/>
    <div class="loading" v-if="loading"></div>
    <div v-else class="sectionCnt">
      <div class="sectionHeader">
        <h2>Kabar Terkini</h2>
        <div class="searchCnt">
          <input type="text" class="search" placeholder="Search...">
          <button class="searchBtn"></button>
        </div>
      </div>
      <div class="sectionBig" v-if="mainContent">
        <div class="sbMain">
          <a :href="`/${mainContent.parent.slug}/read/${mainContent.slug}`">
            <div class="mainImg" :style="{backgroundImage: `url(${mainContent.thumbHd})`}"
              v-if="mainContent.thumbHd"></div>
            <div class="mainImg noImg" v-else></div>
          </a>
          <div class="mainInfo">
            <a :href="`/${mainContent.parent.slug}/read/${mainContent.slug}`">
              <h4>{{mainContent.title}}</h4>
              <p>{{mainContent.description.substr(0, 140)}}<span
                v-if="mainContent.description && mainContent.description.length > 140">...</span>
              </p>
            </a>
            <div class="author" v-if="mainContent.author">
              <h4>{{mainContent.author.name}}</h4>
              <p>{{mainContent.publishDate | moment('ddd, D MMM YYYY HH:mm')}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="sectionSm" v-if="featured && featured.length > 0">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide class="sItem" v-for="(f, i) in featured" :key="i">
            <a :href="`/${f.parent.slug}/read/${f.slug}`">
              <div class="sImg" :style="{backgroundImage: `url(${f.thumb})`}"
                v-if="f.thumb"></div>
              <div class="sImg noImg" v-else></div>
              <h4>{{f.title}}</h4>
            </a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div :class="{theSection: true, hasFeatured: featured && featured.length > 0}">
        <div class="itemCnt">
          <div class="theItem" v-for="(item, i) in results" :key="i">
            <a :href="`/${item.parent.slug}/read/${item.slug}`">
              <div class="itemImg" :style="{backgroundImage: `url(${item.thumb})`}"
                v-if="item.thumb"></div>
              <div class="itemImg noImg" v-else></div>
            </a>
            <div class="itemInfo">
              <a :href="`/${item.parent.slug}/read/${item.slug}`">
                <h4>{{item.title}}</h4>
              </a>
              <div class="author" v-if="item.author">
                <h4>{{item.author.name}}</h4>
                <p>{{item.publishDate | moment('ddd, D MMM YYYY HH:mm')}}</p>
              </div>
            </div>
          </div>
          <div class="loadMoreLoading"></div>
          <div class="loadMore">Muat lebih banyak</div>
        </div>
        <div class="popularCnt">
          <div class="popular">
            <h3>Kabar Terpopuler</h3>
            <div class="popularItem" v-for="(item, i) in popular" :key="i">
              <div class="num"><span v-if="i < 10">0</span>{{i + 1}}</div>
              <a :href="`/${item.parent.slug}/read/${item.slug}`">
                <h4>{{item.title}}</h4>
                <p>{{item.description.substr(0, 140)}}<span
                  v-if="item.description.length > 140">...</span></p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import Header from '@/components/Header.vue';

export default {
  name: 'home',
  components: {
    Header,
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      loading: false,
      page: '',
      menuActive: '',
      results: [],
      featured: [],
      popular: [],
      mainContent: null,
      swiperOptions: {
        slidesPerView: 2,
        breakpoints: {
          680: {
            slidesPerView: 3,
          },
        },
        pagination: {
          el: '.swiper-pagination',
        },
      },
    };
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'chMenuActive',
    ]),
    viewContent(item) {
      if (item.type === 'Article') {
        this.$router.push(`/${item.parent.slug}/read/${item.slug}`);
      } else {
        this.$emit('viewContent', item);
      }
    },
    viewLink(item) {
      if (item.event && item.event.url) {
        window.open(item.event.url);
      }
    },
    getData() {
      this.loading = true;
      this.$http.get(this.$config.uri('article/all?parent=kabar-terkini')).then((r) => {
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.loading = false;
      });
      this.$http.get(this.$config.uri('article/all?parent=kabar-terkini&featured=1')).then((r) => {
        this.featured = (r.data.status === 200) ? r.data.data : [];
        [this.mainContent] = this.featured;
        this.featured.splice(0, 1);
        this.loading = false;
      });
      this.$http.get(this.$config.uri('article/all?parent=kabar-terkini&popular=1')).then((r) => {
        this.popular = (r.data.status === 200) ? r.data.data : [];
      });
    },
  },
  mounted() {
    this.page = this.$route.params.slug;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    document.title = 'Kabar Terkini - Bicara Bumi - Bumi Butuh Aksi';
    this.chMenuActive('bicara-bumi');
    this.getData();
  },
};
</script>

<style scoped lang="scss">
#articles{
  min-height: 100vh;
  background-color: #f4f6f1;
  box-sizing: border-box;
  padding-top: 80px;
}

.sectionCnt{
  max-width: 1240px;
  margin: 0 auto;
  @media (max-width: 1300px) {
    max-width: none;
    margin: 0 20px;
  }
  @media (max-width: 680px) {
    margin: 0 16px;
  }
}

.sectionHeader{
  border-bottom: #999 2px solid;
  position: relative;
  padding: 60px 0 10px;
  @media (max-width: 1200px) {
    padding-top: 30px;
  }
  @media (max-width: 960px) {
    padding-top: 20px;
    // border-bottom: none;
    margin-bottom: 10px;
  }
  @media (max-width: 680px) {
    padding-top: 0;
  }
  h2{
    font-size: 64px;
    font-weight: 800;
    margin: 0;
    @media (max-width: 1200px) {
      font-size: 46px;
    }
    @media (max-width: 680px) {
      font-size: 34px;
      margin-bottom: 4px;
    }
  }
  .searchCnt{
    position: absolute;
    right: 0; top: 80px;
    display: none;
    @media (max-width: 1200px) {
      top: 34px;
    }
    @media (max-width: 960px) {
      position: relative;
      right: auto; top: auto;
    }
    input{
      border: none;
      background-color: #fff;
      font-size: 16px;
      padding: 10px 20px;
      line-height: 1;
      border-radius: 50px;
      border: #ddd 1px solid;
      width: 300px;
      outline: 0;
      &:focus{
        border-color: #222;
      }
      @media (max-width: 960px) {
        width: 100%;
        box-sizing: border-box;
      }
      @media (max-width: 680px) {
        padding: 8px 20px;
      }
    }
    button{
      position: absolute;
      border: none;
      background-color: #fff;
      width: 30px; height: 30px;
      right: 10px; top: 4px;
      background-image: url(../assets/loupe.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .6;
    }
  }
}

.sectionBig{
  padding: 30px 0 0;
  @media (max-width: 960px) {
    padding-top: 16px;
  }
  .sbMain{
    position: relative;
    height: 460px;
    @media (max-width: 1300px) {
      height: 380px;
    }
    @media (max-width: 960px) {
      height: auto;
    }
    a{
      text-decoration: none;
      color: #444;
    }
    .mainImg{
      width: 740px; height: 460px;
      background-color: #999;
      position: absolute;
      left: 0; top: 0;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      @media (max-width: 1300px) {
        width: 560px; height: 380px;
      }
      @media (max-width: 960px) {
        position: static;
        width: auto;
        height: 380px;
        margin-bottom: 16px;
      }
      @media (max-width: 680px) {
        height: 200px;
      }
      &.noImg{
        background-image: url(../assets/image-black-hd.png);
        background-size: 94px auto;
        opacity: .3;
        @media (max-width: 680px) {
          background-size: 46px auto;
        }
      }
    }
    .mainInfo{
      position: absolute;
      top: 50%; left: 780px; right: 0;
      transform: translateY(-50%);
      @media (max-width: 1300px) {
        left: 590px;
      }
      @media (max-width: 960px) {
        position: static;
        transform: none;
        padding-bottom: 20px;
      }
      @media (max-width: 680px) {
        padding-bottom: 0;
      }
      h4{
        font-size: 42px;
        line-height: 1.2;
        font-weight: 800;
        margin: 0 0 10px;
        @media (max-width: 960px) {
          font-size: 34px;
          margin-bottom: 0;
        }
        @media (max-width: 680px) {
          font-size: 24px;
        }
      }
      p{
        font-size: 20px;
        margin: 0 0 20px;
        @media (max-width: 960px) {
          font-size: 18px;
          margin-bottom: 10px;
        }
        @media (max-width: 680px) {
          font-size: 16px;
          margin-bottom: 4px;
        }
      }
      .author{
        h4{
          font-size: 17px;
          font-weight: 800;
          margin: 0 0 2px;
        }
        p{
          font-size: 14px;
          margin: 0;
          font-weight: 600;
        }
      }
    }
  }
}

.sectionSm{
  // display: flex;
  margin: 0 -15px;
  padding: 30px 0 0;
  @media (max-width: 680px) {
    margin: 0 -8px;
  }
  .sItem{
    // width: 33.33333%;
    box-sizing: border-box;
    padding: 0 15px;
    @media (max-width: 680px) {
      padding: 0 8px;
    }
    a{
      color: #444;
      text-decoration: none;
    }
    .sImg{
      height: 280px;
      margin-bottom: 10px;
      background-color: #999;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      cursor: pointer;
      @media (max-width: 1200px) {
        height: 200px;
      }
      @media (max-width: 960px) {
        height: 180px;
        margin-bottom: 6px;
      }
      @media (max-width: 680px) {
        height: 140px;
      }
      &.noImg{
        background-image: url(../assets/image-black.png);
        background-size: 64px auto;
        opacity: .3;
      }
    }
    h4{
      margin: 0;
      font-size: 30px;
      cursor: pointer;
      line-height: 1.2;
      @media (max-width: 960px) {
        font-size: 20px;
        margin-left: 2px;
        line-height: 1.1;
      }
      @media (max-width: 680px) {
        font-size: 17px;
      }
    }
  }
}

.theSection{
  padding-top: 30px;
  display: flex;
  @media (max-width: 960px) {
    display: block;
  }
  &.hasFeatured{
    border-top: #999 2px solid;
    margin-top: 30px;
  }
  .itemCnt{
    width: calc(100% - 360px);
    box-sizing: border-box;
    padding-right: 40px;
    @media (max-width: 960px) {
      width: auto;
    }
    .theItem{
      position: relative;
      padding-left: 286px;
      min-height: 180px;
      margin-bottom: 40px;
      @media (max-width: 680px) {
        padding-left: 116px;
        min-height: 100px;
      }
      .itemImg{
        position: absolute;
        top: 0; left: 0;
        width: 260px; height: 180px;
        background-color: #999;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        @media (max-width: 680px) {
          width: 100px;
          height: 100px;
        }
        &.noImg{
          background-image: url(../assets/image-black.png);
          background-size: 46px auto;
          opacity: .3;
          @media (max-width: 680px) {
            background-size: 34px auto;
          }
        }
      }
      .itemInfo{
        padding-top: 10px;
        @media (max-width: 680px) {
          padding-top: 0;
        }
        a{
          text-decoration: none;
          color: #444;
        }
        h4{
          margin: 0 0 20px;
          font-size: 26px;
          font-weight: 800;
          @media (max-width: 680px) {
            font-size: 22px;
            line-height: 1.2;
            margin-bottom: 6px;
          }
        }
        .author{
          h4{
            font-size: 16px;
            font-weight: 800;
            margin: 0 0 2px;
          }
          p{
            font-size: 14px;
            margin: 0;
            font-weight: 600;
          }
        }
      }
    }
    .loadMoreLoading{
      height: 54px;
      margin-bottom: 40px;
      border-radius: 2px;
      background-image: url(../assets/loading-2.svg);
      background-size: 40px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #e6e8e1;
      display: none;
    }
    .loadMore{
      display: none;
    }
  }
  .popularCnt{
    width: 360px;
    @media (max-width: 960px) {
      width: auto;
      padding: 0 0 40px;
    }
    .popular{
      background-color: #fff;
      padding-bottom: 30px;
      h3{
        font-size: 30px;
        font-weight: 800;
        padding: 30px 30px 10px;
        margin: 0;
      }
      .popularItem{
        position: relative;
        padding: 10px 30px;
        padding-left: 76px;
        .num{
          position: absolute;
          left: 30px; top: 10px;
          font-size: 20px;
          font-weight: 800;
          color: #009b4b;
        }
        a{
          text-decoration: none;
          color: #444;
        }
        h4{
          margin: 0;
          font-size: 20px;
          font-weight: 800;
          line-height: 1.2;
          cursor: pointer;
        }
        p{
          margin: 0;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
}

.loading{
  position: relative;
  overflow: hidden;
  min-height: calc(100vh - 80px);
  background-image: url(../assets/loading-2.svg);
  background-size: 46px auto;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
